import { inject, Injectable } from '@angular/core';
import { StatusState } from '../../states/status.state';

/**
 * Use case for setting a status's isActive property in the state without making an API call.
 * This is useful for reverting the UI state when a user cancels a toggle operation.
 */
@Injectable({ providedIn: 'root' })
export class SetStatusActiveInStateUseCase {
  private readonly _state = inject(StatusState);

  /**
   * Updates the isActive property of a status in the state.
   * @param id - The status ID
   * @param isActive - The new active state
   */
  public execute(id: string, isActive: boolean): void {
    const casesStatuses = this._state.casesStatuses();
    const investigationsStatuses = this._state.investigationsStatuses();

    // Try to find and update in cases statuses
    const casesStatus = casesStatuses.find((s) => s.id === id);
    if (casesStatus) {
      const updated = { ...casesStatus, isActive };
      this._state.updateStatusInCasesList(updated);
      return;
    }

    // Try to find and update in investigations statuses
    const investigationsStatus = investigationsStatuses.find((s) => s.id === id);
    if (investigationsStatus) {
      const updated = { ...investigationsStatus, isActive };
      this._state.updateStatusInInvestigationsList(updated);
    }
  }
}
